import type { ReactNode } from 'react';

/** 페이지 액션 바 (CR-022): 등록·생성·상태 변경 같은 페이지 단위 액션은 본문 아래 오른쪽에 모은다 */
export function PageActions({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <div className={`page-actions ${className}`}>{children}</div>;
}
